import ArrowBackIcon          from '@/assets/icons/ArrowBackIcon';
import PageContainer          from '@/components/pageContainer/PageContainer';
import PageTitle              from '@/components/pageTitle/PageTitle';
import Spinner                from '@/components/spinner/Spinner';
import EntityModel            from '@/models/services/fondations/EntityModel';
import NotFoundPage           from '@/pages/NotFound/NotFoundPage';
import useTranslations        from '@/hooks/useTranslations';
import useEntityRoles         from '@/pages/Entity/hooks/useEntityRoles';
import EntityInfoBox          from '@/pages/Entity/components/Boxes/EntityInfoBox';
import EntityGestionnaireBox  from '@/pages/Entity/components/Boxes/EntityGestionnaireBox';
import EntityManagersBox      from '@/pages/Entity/components/Boxes/EntityManagersBox';
import EntityContactsBox      from '@/pages/Entity/components/Boxes/EntityContactsBox';
import EntityAddressesBox     from '@/pages/Entity/components/Boxes/EntityAddressesBox';
import { Box }                from '@chakra-ui/react';
import PagedCollection        from '@widesk-core/models/PagedCollection';
import useFetch               from '@widesk-core/hooks/useFetch';
import authStore              from '@/stores/authStore';
import { Link }               from 'react-router-dom';
import { useParams }          from 'react-router-dom';
import { useTranslation }     from 'react-i18next';
const EntityPage = () => {
	const { t } = useTranslation();
	const { entityId } = useParams();
	const { getNavigationTranslation } = useTranslations();

	const { data: entity, isLoading } = useFetch(async () => {
		const collection = await new PagedCollection(EntityModel)
			.setItemsPerPage(1)
			.setFilter('id', [entityId as string])
			.list();
		return collection.first();
	}, true);

	const { roles, refetch: refetchRoles } = useEntityRoles(entity ?? undefined);

	const isReadOnly = !!entity?.id && entity.get('accountManagerUrn') !== authStore.currentUser?.urn;

	if (isLoading) return <Spinner />;
	if (!entity?.id) return <NotFoundPage />;

	return (
		<PageContainer>
			<Link to={getNavigationTranslation('entities', 'path')} style={{ width: 'fit-content' }}>
				<Box display="flex" alignItems="center" gap="15px" lineHeight="0px" pt="10px" pb="10px">
					<ArrowBackIcon style={{ marginBottom: '0.5px' }} size="lg" />
					<PageTitle>{t('pages.entity.label')}</PageTitle>
				</Box>
			</Link>

			<EntityInfoBox entity={entity} />

			<Box display="flex" gap="20px" flexWrap="wrap">
				<EntityGestionnaireBox contact={roles?.gestionnaireContact} />
				<EntityManagersBox
					entity={entity}
					managers={roles?.managerContacts ?? []}
					assignableContacts={roles?.assignableContacts ?? []}
					contactFiles={roles?.contactFiles ?? []}
					isReadOnly={isReadOnly}
					onRolesChange={refetchRoles}
				/>
			</Box>

			<EntityContactsBox
				entity={entity}
				gestionnaireId={roles?.gestionnaireId}
				managerIds={roles?.managerIds ?? new Set()}
				isReadOnly={isReadOnly}
				onRolesChange={refetchRoles}
			/>

			<EntityAddressesBox entity={entity} isReadOnly={isReadOnly} />
		</PageContainer>
	);
};

export default EntityPage;
